import { render, staticRenderFns } from "./TheEmailVerification.vue?vue&type=template&id=b4f5a3fa"
import script from "./TheEmailVerification.vue?vue&type=script&lang=js"
export * from "./TheEmailVerification.vue?vue&type=script&lang=js"
import style0 from "./TheEmailVerification.vue?vue&type=style&index=0&id=b4f5a3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports